import { Button } from "primereact/button";
import { useNavigate, useSearchParams } from "react-router-dom";

import {
  forgotPassword,
  Titlelogin,
  loginSubtitle,
  rememberMe,
  inputPassword,
  formLogin,
  inputEmailLogin,
} from "../_constants";
import { GenericLandingCardHeader } from "components";
import { CheckboxForm, EmailInput, PasswordInput } from "./shared/inputs";
import { LoginRequest } from "interfaces";
import { login } from "services/AuthenticationService";
import {
  setTokenInStorage,
  setRefreshTokenInStorage,
  getDecodedToken,
} from "utils";
import { useAppDispatch } from "store/store";
import { resetPasswordForm } from "store/slicer/resetPasswordFormSlice";
import { setUserProfile } from "store/slicer/ProfiloSlice";
import { setLoginFormValid } from "store/slicer/FormLoginValidationSlice";
import { resetProjectsState } from "store/slicer/GestioneProjectsSlice";

export const LoginForm = ({ control, handleSubmit }: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const onSubmit = (data: LoginRequest) => {
    login(data)
      .then((res) => {
        setTokenInStorage(res.data.accessToken);
        setRefreshTokenInStorage(res.data.refreshToken);
        let decodedToken = getDecodedToken();
        dispatch(resetProjectsState());
        dispatch(
          setUserProfile({
            token: res.data.accessToken,
            firstName: decodedToken?.firstName,
            lastName: decodedToken?.lastName,
            email: decodedToken?.userName,
            role: decodedToken?.role,
          })
        );

        if (
          searchParams.get("code")?.length &&
          searchParams.get("projectId")?.length
        ) {
          navigate(
            `/bo/check-project-share-code?code=${searchParams.get(
              "code"
            )}&projectId=${searchParams.get("projectId")}`
          );
        } else {
          navigate("/bo");
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          dispatch(setLoginFormValid(false));
        }
      });
  };

  const navigateToResetPassword = () => {
    dispatch(resetPasswordForm());
    navigate("/reset-password");
  };

  return (
    <>
      <GenericLandingCardHeader title={Titlelogin} subtitle={loginSubtitle} />
      <form
        className="margin-top-32"
        id={formLogin}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="container-input flex-container justify-between wrap">
          <div className="input margin-bottom-8">
            <EmailInput
              control={control}
              isLogin={true}
              placeholder={inputEmailLogin}
            />
          </div>
          <div className="input">
            <PasswordInput
              control={control}
              name="password"
              placeholder={inputPassword}
              isLogin={true}
            />
          </div>
          <div className="margin-top-16 flex-container justify-between width-100  ">
            <div className="flex-container align-center ">
              <CheckboxForm control={control} />
              <p className="text-checkbox margin-left-9">{rememberMe}</p>
            </div>
            <Button
              className="padd-0"
              label={forgotPassword}
              type="button"
              link
              onClick={navigateToResetPassword}
            />
          </div>
        </div>
      </form>
    </>
  );
};
